import { environments } from "@jsq/utils";

export const throttledSampleRate = 40;

export const throttledEnvs: readonly string[] = [
  environments.production,
  environments.prodops,
  environments.cit,
];
